import styled from 'styled-components';

export const Wrapper = styled.input`
  margin: 0;
  padding: 0;

  background: transparent;

  border: 0;
  outline: none;

  font-family: 'Poppins', sans-serif;
  font-size: 1.2715rem;

  color: rgba(0, 0, 0, 0.87);

  cursor: pointer;
`;

export const WrapperContent = styled.div`
  position: relative;

  > div {
    position: absolute;

    top: calc(50% - 10px);
    left: calc(50% - 10px);
  }
`;
